<script>
import { CLIMA_COLORS } from "../climaColors";
import graphApexChart from "../../dashboard/GraphApexChart.vue";
export default {
  template: `
    <div>
      <div class="box" v-show="!isEmpty && location === 'cell'">
        <h2 class="tooltip-title with-divider">{{title}}</h2>
        <div class="tooltip-group-header" :class="{ 'with-divider': !singleVar }" v-if="groupName">
          <span class="tooltip-group-name">{{ groupName }}</span>
          <span class="tooltip-color-square" :style="{ backgroundColor: totalColor, marginLeft: 'auto' }"></span>
          <span class="tooltip-group-total" v-if="totalValue !== null">{{ totalValue }}%</span>
        </div>
        <graph-apex-chart v-if='dataGraph && !singleVar' :data='dataGraph'></graph-apex-chart>
      </div>
      <div class="ag-custom-tooltip" v-show="location === 'header'">
        {{title}}
      </div>
    </div>
  `,
  data: function() {
    return {
      type: {
        apoyod: ["apsd", "vincd", "apod"],
        calidadd: ["excd", "cycd", "segd"],
        innovaciond: ["autd", "agid", "mejd"],
        metasd: ["logrd", "servd", "repd"],
        lidd: ["lidd"],
        engad: ["engad"],
        recd: ["recd"],
        compd: ["compd"],
      },
      title: "",
      quadrant: "",
      dataGraph: {},
      location: null,
      isEmpty: false,
      groupName: "",
      totalValue: null,
      totalColor: "#a5a5a5",
      singleVar: false,
    };
  },
  props: {
    nameQuadrants: {
      type: Object,
      required: true,
    },
    nameRanges: {
      type: Object,
      required: true,
    },
    getRange: {
      type: Function,
      required: true,
    },
  },
  beforeMount() {
    const params = this.$parent.params;
    this.location = params.location;
    this.title = params.colDef.headerName;
    this.quadrant = params.colDef.field;
    if (this.location === "cell") {
      this.singleVar = (this.type[this.quadrant] || []).length === 1;
      this.dataGraph = this.createDataGraphHorizontalBar(params.data);
      this.isEmpty = params.data.empty || false;
      this.groupName = params.data.name || "";
      // Value and square color must match the hovered cell (this dimension's
      // value and range), not the overall row total.
      const cell = params.data[this.quadrant];
      if (cell && cell.p != null) {
        this.totalValue = Number(cell.p).toFixed(1);
        const colors = [
          "#a5a5a5",
          CLIMA_COLORS[1],
          CLIMA_COLORS[2],
          CLIMA_COLORS[3],
          CLIMA_COLORS[4],
          CLIMA_COLORS[5],
          CLIMA_COLORS[6],
        ];
        this.totalColor = colors[this.getRange(cell.p)];
      }
    }
  },
  methods: {
    createDataGraphHorizontalBar: function(data) {
      const paddingLeft = {
        apoyod: 75,
        calidadd: 65,
        innovaciond: 55,
        metasd: 55,
        lidd: 55,
        engad: 65,
        recd: 55,
        compd: 55,
      };
      let graph = {
        series: [
          {
            name: "Actual",
            data: [
              {
                x: "Datos",
                y: 12,
                goals: [
                  {
                    name: "Anterior",
                    value: 14,
                    strokeWidth: 2,
                    strokeDashArray: 2,
                    strokeColor: "#775DD0",
                  },
                ],
              },
            ],
          },
        ],
        options: {
          chart: {
            width: "100%",
            height: "100%",
            redrawOnParentResize: true,
            redrawOnWindowResize: false,
            type: "bar",
            toolbar: {
              show: false,
            },
          },
          plotOptions: {
            bar: {
              horizontal: true,
              borderRadius: 4,
              distributed: true,
              dataLabels: {
                position: "top",
              },
              colors: {
                backgroundBarColors: ["#f9f8f8"],
              },
            },
          },
          grid: {
            show: false,
            padding: {
              top: 0,
              right: 10,
              bottom: 10,
              left: paddingLeft[this.quadrant],
            },
          },
          colors: [],
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + "%";
            },
            textAnchor: "end",
            offsetX: 0,
            offsetY: 7,
            style: {
              fontSize: "11px",
              fontWeight: 600,
              colors: ["#414040"],
            },
            background: {
              enabled: false,
            },
          },
          tooltip: {
            enabled: false,
          },
          xaxis: {
            min: 0,
            max: 100,
          },
          yaxis: {
            position: "left",
            labels: {
              align: "right",
              show: true,
            },
          },
          legend: {
            show: false,
          },
        },
        width: "280",
        height: "120",
        type: "bar",
      };
      if (data) {
        const colors = [
          "#a5a5a5",
          CLIMA_COLORS[1],
          CLIMA_COLORS[2],
          CLIMA_COLORS[3],
          CLIMA_COLORS[4],
          CLIMA_COLORS[5],
          CLIMA_COLORS[6],
        ];
        const labels = this.type[this.quadrant];
        const dataG = labels.map((x) => {
          const v = data[x].p | 0;
          const vComp = Object.keys(data.comparison).length
            ? data.comparison[x].p | 0
            : 0;
          const d = {
            x: this.nameQuadrants[x],
            y: v,
          };

          if (data.comparison && vComp) {
            d.goals = [
              {
                name: "Anterior",
                value: vComp,
                strokeWidth: 2,
                strokeDashArray: 2,
                strokeColor: "#000000",
              },
            ];
          }

          graph.options.colors.push(colors[this.getRange(v)]);
          return d;
        });
        graph.series[0].data = dataG;
        // if (labels.length < 2) graph.options.yaxis.labels.show = false;
      }
      return graph;
    },
  },
  components: {
    graphApexChart,
  },
};
</script>
<style lang="scss">
.tooltip-title {
  font-size: 14px;
  font-weight: 700;
  color: #363636;
  margin-bottom: 4px;
  line-height: 1.2;
}

.tooltip-group-header {
  display: flex;
  align-items: center;
  gap: 6px;
}

.tooltip-group-header.with-divider {
  margin-bottom: 6px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e9e9e9;
}

.tooltip-color-square {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
}

.tooltip-group-name {
  font-weight: 600;
  color: #4a4a4a;
  font-size: 13px;
}

.tooltip-group-total {
  font-weight: 700;
  color: #363636;
  font-size: 13px;
}

.ag-custom-tooltip {
  background: #fff;
  color: #181d1f;
  border: 1px solid #babfc7;
  border-radius: 2px;
  padding: 6px 8px;
  font-size: 12px;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  white-space: normal;
  max-width: 300px;
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/climan/components/tooltipGraphBarHClima.vue